module.exports = __webpack_public_path__ + "img/hyal-7@2x.93379d22.png";